import { render, staticRenderFns } from "./MunuServidor.vue?vue&type=template&id=3f2ead09"
import script from "./MunuServidor.vue?vue&type=script&lang=js"
export * from "./MunuServidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports